export function navIcon(tab) {
  const icons = {
    routines: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 7v5h-5M4 17v-5h5M6 7a7 7 0 0 1 12 0l2 3M4 14l2 3a7 7 0 0 0 12 0"/></svg>`,
    docs: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5a2 2 0 0 1 2-2h5l2 2h5a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"/></svg>`,
    outline: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 6h12M8 12h12M8 18h12"/><circle cx="4" cy="6" r="1"/><circle cx="4" cy="12" r="1"/><circle cx="4" cy="18" r="1"/></svg>`,
    notes: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3h9l3 3v15H6z"/><path d="M14 3v4h4M9 12h6M9 16h6"/></svg>`,
    board: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h5v14H4zM10 5h5v9h-5zM16 5h4v12h-4z"/></svg>`,
    timeline: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M4 17h16"/><path d="M7 5v4M17 15v4"/><rect x="8" y="11" width="8" height="4" rx="1"/></svg>`,
    mindmap: `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="5" cy="12" r="2"/><circle cx="19" cy="6" r="2"/><circle cx="19" cy="18" r="2"/><path d="M7 12h5M12 12V6h5M12 12v6h5"/></svg>`,
    bubble: `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="10" r="5"/><circle cx="17" cy="16" r="3"/><circle cx="17" cy="7" r="2"/></svg>`,
    more: `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="5" cy="12" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="19" cy="12" r="1.5"/></svg>`,
  };
  return icons[tab] || "";
}

export function closeIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>`;
}

export function filterIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16M7 12h10M10 18h4"/></svg>`;
}

export function searchIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>`;
}

export function syncIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12a8 8 0 0 0-14.8-4M4 8V4h4M4 12a8 8 0 0 0 14.8 4M20 16v4h-4"/></svg>`;
}

/** Server status dot (engine/core/server-status.js level: ok, busy, problem, offline, none). */
export function syncDotIcon(level) {
  return `<span class="mobile-sync-dot ${level || "none"}"></span>`;
}

export function lockIcon() {
  return `<svg class="mobile-subtitle-icon" viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10" width="14" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>`;
}

export function emptyStateIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5h14v14H5z"/><path d="M8 9h8M8 13h5"/></svg>`;
}

export function targetIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3"/></svg>`;
}

export function mapIcon() {
  // Document row icon: a mini map (root node with two children). Deliberately
  // not the same layout as mindmapIcon (bottom tab) so a map ITEM doesn't
  // read as the Mindmap VIEW. Rotated -45° so the triangle reads as a graph
  // rather than a bunch of cherries.
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><g transform="rotate(-45 12 12)"><circle cx="12" cy="5.5" r="2.6"/><circle cx="5.5" cy="18" r="2.6"/><circle cx="18.5" cy="18" r="2.6"/><path d="M10.8 7.8 6.7 15.7"/><path d="M13.2 7.8 17.3 15.7"/></g></svg>`;
}

export function layoutModeIcon() {
  // Central spine with branches both sides — mindmap layout-direction cycle.
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4v16"/><path d="M9 8H3M9 16H5"/><path d="M15 8h6M15 16h4"/></svg>`;
}

export function mindmapIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="5" cy="12" r="3"/><circle cx="17" cy="6" r="3"/><circle cx="17" cy="18" r="3"/><path d="M8 11l6-4M8 13l6 4"/></svg>`;
}

export function bubbleIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="8" cy="9" r="4"/><circle cx="16" cy="15" r="5"/><circle cx="17" cy="6" r="2"/></svg>`;
}

export function refnoteIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7 0l2-2a5 5 0 0 0-7-7l-1 1"/><path d="M14 11a5 5 0 0 0-7 0l-2 2a5 5 0 0 0 7 7l1-1"/></svg>`;
}

export function folderIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h7l2 2h9v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>`;
}

export function bellIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6"/><path d="M10 19a2.2 2.2 0 0 0 4 0"/></svg>`;
}

export function moreIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="5" cy="12" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="19" cy="12" r="1.5"/></svg>`;
}

export function pencilIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20h4l11-11a2.8 2.8 0 0 0-4-4L4 16v4z"/><path d="M13 6l5 5"/></svg>`;
}

export function moveIcon() {
  // Branch-with-arrow — node moving from one parent into another. Reads more
  // intuitively as "move to" than the four-direction cross used previously,
  // which collided visually with a resize/free-move tool.
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5v6a4 4 0 0 0 4 4h7"/><path d="M13 11l4 4-4 4"/></svg>`;
}

export function fitAllIcon() {
  // Four corners pointing inward — universal "fit content to viewport".
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/></svg>`;
}

export function expandAllIcon() {
  // Circled +/− to match the fold toggles drawn on the nodes themselves —
  // squared variants read as zoom controls next to the fit button.
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 8v8M8 12h8"/></svg>`;
}

export function collapseAllIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M8 12h8"/></svg>`;
}

export function collapseChildrenIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 6h14M9 12h10M9 18h10M5 12l-1 0M5 18l-1 0M5 12v6"/></svg>`;
}

export function noteMarkerIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 4h11l3 3v13H5z"/><path d="M16 4v3h3M8 11h8M8 15h6"/></svg>`;
}

export function rowTallerIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h16M4 12h16M4 19h16"/><path d="M12 3v3M12 21v-3"/></svg>`;
}

export function rowShorterIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 8h16M4 16h16"/><path d="M9 12h6"/></svg>`;
}

export function appLogoSvg() {
  // Same circle/orbit motif used in the favicon.
  return `<svg viewBox="0 0 100 100" aria-hidden="true"><circle cx="50" cy="50" r="45" fill="currentColor" opacity="0.12"/><circle cx="50" cy="50" r="34" fill="none" stroke="currentColor" stroke-width="3" opacity="0.55"/><circle cx="50" cy="50" r="14" fill="currentColor"/></svg>`;
}

export function propertiesIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 10v6M12 7h.01"/></svg>`;
}

export function trashIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2M9 10v8M15 10v8M6 6l1 15h10l1-15"/></svg>`;
}

export function chevronIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>`;
}

export function plusIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>`;
}

export function minusIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14"/></svg>`;
}

export function cameraIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 8h3l2-3h8l2 3h3v11H3z"/><circle cx="12" cy="13" r="3.5"/></svg>`;
}

export function paperclipIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 11.5l-8.4 8.4a5 5 0 0 1-7.1-7.1l8.7-8.7a3.4 3.4 0 0 1 4.8 4.8l-8.6 8.6a1.8 1.8 0 0 1-2.5-2.5l7.9-7.9"/></svg>`;
}
